import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://rohuyvzuoibjqhhslkek.supabase.co'
const supabaseAnonKey = 'sb_publishable_QAPukNpdpMDFO_19zT2cBQ_G2diL2O6'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
